<template>
  <div class="has-plans-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-2-tablet is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Qual plano você gostaria?
          </p>
        </div>
      </div>
      <div class="columns mt-6 mt-4-mobile is-multiline">
        <div class="column is-one-third-desktop is-half-tablet is-full-mobile mb-4-mobile" v-for="(plan, index) in filteredPlans" :key="index">
          <div class="is-flex is-justify-content-center is-full">
            <div
                class="box plan-box is-size-3 mx-4 mx-2-mobile p-6 p-4-mobile is-fullwidth has-text-centered"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 is-size-3-tablet is-size-4-mobile has-text-weight-bold">
                    {{ plan.name }}
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width price-container">
                    <span class="has-text-grey-dark is-size-6 is-size-7-mobile is-desktop is-pulled-left currency-symbol">R$</span>
                    <span class="is-size-2 is-size-3-tablet is-size-3-mobile has-text-weight-semibold has-text-black">
                      {{ formatPrice(plan.price) }}
                    </span>
                    <span class="has-text-grey-dark is-size-6 is-size-7-mobile per-month">/MÊS</span>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <div>
                    <span class="has-text-grey-dark is-size-5 is-size-6-mobile">
                      {{ plan.max_accesses }} acessos
                    </span>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <div>
                    <span class="has-text-grey-dark is-size-5 is-size-6-mobile">
                      R$ {{ formatPrice(plan.price * 12) }} por ano
                    </span>
                    <!-- <span v-if="plan.discount_percentage" class="tag is-primary is-small is-size-6">
                      DESCONTO DE {{ plan.discount_percentage }}%
                    </span>
                    <span v-else class="tag is-primary is-small is-size-6">
                      SEM DESCONTO
                    </span> -->
                  </div>
                </div>
              </div>
              <div class="columns mt-2">
                <div class="column is-full">
                  <button
                      class="button is-primary is-size-5 is-size-6-mobile is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="choosePlan(plan)"
                  >
                    <div class="is-fullwidth">
                      Quero este
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import plans from '@/apis/plans'

export default {

  name: 'plans',

  data() {
    return {
      plans: []
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  computed: {
    filteredPlans() {
      const plans = []
      if (this.formData.partner.data.id) {
        for (const plan of this.plans) {
          if (plan.partners.length > 0) {
            plans.push(plan)
          }
        }
      } else {
        for (const plan of this.plans) {
          if (plan.partners.length === 0) {
            plans.push(plan)
          }
        }
      }
      return plans
    }
  },

  methods: {
    async getPlans() {
      this.plans = await plans.get(this.formData.integration.data.type)
    },
    cleanData() {
      this.plans = []
      this.formData.integration.data.type = null
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    choosePlan(plan) {
      this.formData.plan.showStep            = true
      this.formData.plan.data                = plan
      this.formData.plan.data.original_price = plan.price
      this.$emit('nextTab')
    }

  }

}

</script>

<style lang="scss" scoped>
.has-plans-component {
  overflow-x: hidden;
  width: 100%;
  
  .plan-box {
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 15px rgba(0,0,0,0.1);
    }
    
    .price-container {
      position: relative;
      display: inline-flex;
      align-items: baseline;
      justify-content: center;
      margin: 0 auto;
      
      .currency-symbol {
        position: relative;
        top: -5px;
      }
      
      .per-month {
        position: relative;
        bottom: 0;
      }
    }
    
    button {
      transition: all 0.2s ease;
      
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .has-plans-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-4-mobile {
      font-size: 1.2rem !important;
    }
    
    .is-size-6-mobile {
      font-size: 0.9rem !important;
    }
    
    .is-size-7-mobile {
      font-size: 0.75rem !important;
    }
    
    .mx-2-mobile {
      margin-left: 0.5rem !important;
      margin-right: 0.5rem !important;
    }
    
    .mb-4-mobile {
      margin-bottom: 1rem !important;
    }
    
    .mt-4-mobile {
      margin-top: 1rem !important;
    }
    
    .p-4-mobile {
      padding: 1rem !important;
    }
    
    .plan-box {
      min-height: auto;
      
      .price-container {
        .currency-symbol {
          top: -3px;
        }
      }
    }
    
    .column {
      padding: 0.5rem;
    }
  }
}

@media screen and (max-width: 480px) {
  .has-plans-component {
    .plan-box {
      margin-left: 0.25rem !important;
      margin-right: 0.25rem !important;
      padding: 0.75rem !important;
    }
    
    .column {
      padding: 0.25rem;
    }
    
    .columns {
      margin-left: -0.25rem;
      margin-right: -0.25rem;
    }
  }
}
</style>